import { observer } from "mobx-react-lite";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import GitHubIcon from "@mui/icons-material/GitHub";
import { Navigate, useLocation } from "react-router-dom";

import LogoIcon from "../components/LogoIcon";
import Copyright from "../components/Copyright";
import { useStore } from "../store";

function Login() {
  const location = useLocation();
  const store = useStore();

  const from = location.state?.from?.pathname || "/";
  if (store.userInfo) {
    return <Navigate to={from} />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <LogoIcon sx={{ m: 1, width: 64, height: 64 }} />
        <Typography component="h1" variant="h4" paragraph={true}>
          Sign in to Giters
        </Typography>
        <Typography sx={{ width: "100%" }} paragraph={true} align="left">
          If you want to control your GitHub data display, you need login with
          your GitHub's account for check data owner.
        </Typography>
        <Typography sx={{ width: "100%" }} paragraph={true} align="left">
          Statement, we just use it for check ownership.
          {/* And we'll make more useful function for developers. */}
        </Typography>
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          href="/api/auth"
          startIcon={<GitHubIcon />}
          size="large"
          color="primary"
        >
          Continue with GitHub
        </Button>
      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
}

export default observer(Login);
